import { StaticInterface } from '../../../helpers/static-interface';
import TpxIconCardUtils from '../../molecules/icon-card/iconCard.utils';

export interface ITpxIconGridUtils {}

export interface IStaticIconGridUtils {
  new (...args: any[]): ITpxIconGridUtils;
  init(): void;
}

/**
 * IconGrid utilities
 * @class
 */
export default class TpxIconGridUtils
  implements StaticInterface<IStaticIconGridUtils, typeof TpxIconGridUtils>
{
  static init(scope?: HTMLElement) {
    [
      ...(scope || document).querySelectorAll('[data-component="icon-grid"]'),
    ].forEach((block) => {
      block
        .querySelectorAll('[data-component="icon-card"]')
        .forEach((card) => new TpxIconCardUtils(card as HTMLElement));
    });
  }
}
